import React, { ComponentProps } from 'react';
import { DOCUMENT_TITLE_SUFFIX } from '../../core/config';
import { DefaultPageLayout } from '../../visual-components/default-page-layout/default-page-layout';
import { AppHeaderManager } from './app-header-manager';

type Props = {
  children: React.ReactNode;
  documentTitle: string;
} & Pick<ComponentProps<typeof DefaultPageLayout>, 'pageHeader'>;

export const PageContainer: React.FC<Props> = ({ children, documentTitle, pageHeader }) => {
  const title = `${documentTitle} | ${DOCUMENT_TITLE_SUFFIX}`;

  return (
    <>
      <title>{title}</title>
      <DefaultPageLayout appHeader={<AppHeaderManager />} pageHeader={pageHeader}>
        {children}
      </DefaultPageLayout>
    </>
  );
};
